(function () {
  function initRefrigeratedConsolePage() {
    if (!document.querySelector('[data-rc-section]') || document.documentElement.dataset.rcConsoleReady === 'true') return;
    document.documentElement.dataset.rcConsoleReady = 'true';

      document.querySelectorAll(".faq2-item").forEach(function (item) {
        const q = item.querySelector(".faq2-q");
        const a = item.querySelector(".faq2-a");
        function sync() {
          const open = item.classList.contains("is-open");
          a.style.maxHeight = open ? a.scrollHeight + "px" : "0px";
          q.setAttribute("aria-expanded", open ? "true" : "false");
        }
        sync();
        q.addEventListener("click", function () { item.classList.toggle("is-open"); sync(); });
        window.addEventListener("resize", sync);
      });
      const rankTable = document.getElementById("rankTable");
      if (rankTable) {
        const card = document.getElementById("rankHeroCard");
        const heads = Array.from(rankTable.querySelectorAll(".rank-col-head"));
        const cells = Array.from(rankTable.querySelectorAll(".rank-cell"));
        const picks = [];
        const names = ["Tuscany Luxury","Tuscany Ultimate","Oslo Luxury","Oslo Ultimate"];
        let col = 2;
        function place() {
          const heroes = rankTable.querySelectorAll(".is-hero");
          if (!heroes.length || window.innerWidth <= 760) { card.style.display = "none"; return; }
          card.style.display = "block";
          const first = heroes[0].getBoundingClientRect();
          const last = heroes[heroes.length - 1].getBoundingClientRect();
          const base = rankTable.getBoundingClientRect();
          card.style.left = (first.left - base.left - 6) + "px";
          card.style.width = (first.width + 12) + "px";
          card.style.top = (first.top - base.top - 8) + "px";
          card.style.bottom = (base.bottom - last.bottom - 8) + "px";
        }
        function focus(i) {
          col = i;
          heads.forEach(function (el) { el.classList.toggle("is-hero", +el.dataset.col === i); });
          cells.forEach(function (el) { el.classList.toggle("is-hero", +el.dataset.col === i); });
          picks.forEach(function (b) { const on = +b.dataset.pick === i; b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", on ? "true" : "false"); });
          place();
        }
        heads.concat(picks).forEach(function (b) { b.addEventListener("click", function () { focus(+b.dataset.pick); }); });
        requestAnimationFrame(place);
        window.addEventListener("resize", place);
        window.addEventListener("load", place);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
        if (window.ResizeObserver) new ResizeObserver(place).observe(rankTable);
      }
      const swItems = [{"chip":"20000 Nappa grade","p":["Semi-Aniline Italian Nappa Leather 20000 on every seat in the collection — dyed through rather than surface-coated, so it keeps a soft hand, breathes through a long session and ages instead of cracking.","Tanned to resist scratches, which is what makes it pet-friendly without a plastic topcoat."]},{"chip":"Hour three feels like hour one","p":["Comfort-Matrix™ layers memory foam, cooling gel and support springs over a high-density base. The Oslo seats add double-layered high-resiliency foam tuned to the feel of a plush mattress.","Engineered rather than stuffed, so the seat still supports you in year five."]},{"chip":"Built in, not bolted on","p":["Refrigeration, a wireless charging surface and a power-operated cupholder share one integrated unit in the middle of the row. Cold drinks and a charged phone stop being a reason to pause the film.","USB-A and 18W USB-C sit on the black chrome controller beside you."]},{"chip":"Finished back panel","p":["Every seat closes with a leather back finishing panel, and the Ultimate models carry the hide the whole way around. The row can sit in the middle of the room instead of hiding against drywall.","French diamond stitching holds each panel square through years of reclining."]}];
      const swWords = Array.from(document.querySelectorAll(".sw-word"));
      if (swWords.length) {
        const swImgs = Array.from(document.querySelectorAll("[data-swimg]"));
        const swCopy = document.getElementById("swCopy");
        const swChip = document.getElementById("swChip");
        swWords.forEach(function (btn, i) {
          btn.addEventListener("click", function () {
            swWords.forEach(function (b, n) { b.classList.toggle("is-on", n === i); b.setAttribute("aria-pressed", n === i ? "true" : "false"); });
            swImgs.forEach(function (img, n) { img.classList.toggle("is-on", n === i); });
            swCopy.innerHTML = swItems[i].p.map(function (x) { return "<p>" + x + "</p>"; }).join("");
            swChip.innerHTML = '<i aria-hidden="true"></i>' + swItems[i].chip;
          });
        });
      }
      const spotData = [{"t":"Semi-Aniline Italian Nappa 20000","img":"nappa-leather-detail","p":["A named leather grade, not a marketing phrase. The hide is dyed through rather than surface-coated, which is what gives it depth of colour, a soft hand and real breathability through a long session.","The same grade runs across all four seats in the collection; on the Ultimate models it continues around the back of the chair as well."]},{"t":"The refrigerated console","img":"spot-fridge","p":["Refrigeration sits inside the centre console, so cold drinks stay within reach of every seat in the row.","It is built into the seating rather than added beside it — no separate cabinet, no cable running across the floor."]},{"t":"Power cupholder and wireless charging","img":"spot-cupholder","p":["Press once and the cupholder extends from the console; press again and it folds away flush.","The console surface charges a phone wirelessly, and the controller carries USB-A alongside an 18W USB-C port."]},{"t":"Power seating with memory","img":"spot-seating","p":["Headrest, lumbar and recline each adjust under power, so the seat is shaped to you rather than to an average.","Seat memory brings that position back the next time you sit down, film after film."]},{"t":"Seven colours of ambient light","img":"ambient-lighting-detail","p":["Light rings the cupholders and washes under the base of every seat, in seven selectable colours.","Bright enough to find your row in the dark, never bright enough to compete with the screen."]}];
      const spotButtons = Array.from(document.querySelectorAll(".spot"));
      const drawer = document.getElementById("spotDrawer");
      const backdrop = document.getElementById("spotBackdrop");
      if (spotButtons.length && drawer && backdrop) {
        const imgEl = document.getElementById("spotImage");
        const titleEl = document.getElementById("spotTitle");
        const copyEl = document.getElementById("spotCopy");
        let current = 0;
        function show(i) {
          current = (i + spotData.length) % spotData.length;
          const d = spotData[current];
          const pre = document.querySelector('img[data-asset="' + d.img + '"]');
          imgEl.src = pre ? pre.src : d.img;
          imgEl.alt = d.t;
          titleEl.textContent = d.t;
          copyEl.innerHTML = d.p.map(function (x) { return "<p>" + x + "</p>"; }).join("");
          spotButtons.forEach(function (b, n) { b.classList.toggle("is-active", n === current); });
        }
        function open(i) {
          show(i);
          drawer.classList.add("is-open");
          backdrop.classList.add("is-open");
          drawer.setAttribute("aria-hidden", "false");
        }
        function close() {
          drawer.classList.remove("is-open");
          backdrop.classList.remove("is-open");
          drawer.setAttribute("aria-hidden", "true");
          spotButtons.forEach(function (b) { b.classList.remove("is-active"); });
        }
        spotButtons.forEach(function (b, i) { b.addEventListener("click", function () { open(i); }); });
        document.getElementById("spotClose").addEventListener("click", close);
        backdrop.addEventListener("click", close);
        document.getElementById("spotPrev").addEventListener("click", function () { show(current - 1); });
        document.getElementById("spotNext").addEventListener("click", function () { show(current + 1); });
        document.addEventListener("keydown", function (e) {
          if (!drawer.classList.contains("is-open")) return;
          if (e.key === "Escape") close();
          if (e.key === "ArrowLeft") show(current - 1);
          if (e.key === "ArrowRight") show(current + 1);
        });
      }
      const numSec = document.getElementById("numSec");
      const numPins = Array.from(document.querySelectorAll(".num-pin"));
      if (numSec && numPins.length) {
        let ticking = false;
        function drawNums() {
          ticking = false;
          if (window.innerWidth <= 1080) {
            numPins.forEach(function (pin) {
              pin.style.opacity = "";
              const stem = pin.querySelector(".num-stem");
              if (stem) stem.style.transform = "";
            });
            return;
          }
          const rect = numSec.getBoundingClientRect();
          const span = rect.height - window.innerHeight;
          const p = span > 0 ? Math.min(1, Math.max(0, -rect.top / span)) : 0;
          numPins.forEach(function (pin, i) {
            const start = 0.08 + i * 0.17;
            const t = Math.min(1, Math.max(0, (p - start) / 0.22));
            const eased = t * t * (3 - 2 * t);
            pin.style.opacity = Math.min(1, t * 2.6).toFixed(3);
            const stem = pin.querySelector(".num-stem");
            if (stem) stem.style.transform = "scaleY(" + eased.toFixed(3) + ")";
          });
        }
        window.addEventListener("scroll", function () {
          if (!ticking) { ticking = true; requestAnimationFrame(drawNums); }
        }, { passive: true });
        window.addEventListener("resize", drawNums);
        drawNums();
      }
      if (window.gsap && window.ScrollTrigger && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        gsap.registerPlugin(ScrollTrigger);
        const heroImg = document.querySelector(".col-hero > img");
        if (heroImg) {
          gsap.to(heroImg, { yPercent: 14, scale: 1.06, ease: "none", scrollTrigger: { trigger: ".col-hero", start: "top top", end: "bottom top", scrub: true } });
          gsap.from(".col-hero-inner > *", { y: 28, opacity: 0, duration: 1, stagger: .12, ease: "power3.out", delay: .1 });
        }
        gsap.utils.toArray(".col-title, .col-sub, .rank-head > *, .rev-head > *, .num-head > *").forEach(function (el) {
          gsap.from(el, { y: 26, opacity: 0, duration: .9, ease: "power3.out", scrollTrigger: { trigger: el, start: "top 88%", once: true } });
        });
        [".assure-grid > *", ".stat-grid > *", ".rev-col > *"].forEach(function (sel) {
          const items = gsap.utils.toArray(sel);
          if (!items.length) return;
          gsap.from(items, { y: 40, opacity: 0, duration: .9, stagger: .09, ease: "power3.out", scrollTrigger: { trigger: items[0].parentElement, start: "top 84%", once: true } });
        });
        gsap.utils.toArray(".spot-scene, .sw-media, .rank-table, .col-close2-inner").forEach(function (el) {
          gsap.from(el, { y: 36, opacity: 0, scale: .985, duration: 1, ease: "power3.out", scrollTrigger: { trigger: el, start: "top 86%", once: true } });
        });
        gsap.from(".sw-word", { x: -24, opacity: 0, duration: .8, stagger: .08, ease: "power3.out", scrollTrigger: { trigger: ".sw-words", start: "top 84%", once: true } });
        gsap.from(".spot", { scale: 0, opacity: 0, duration: .6, stagger: .08, ease: "back.out(2)", scrollTrigger: { trigger: ".spot-scene", start: "top 70%", once: true } });
        gsap.utils.toArray(".sw-media, .spot-scene").forEach(function (el) {
          const img = el.querySelector("img");
          if (img) gsap.fromTo(img, { yPercent: -5 }, { yPercent: 5, ease: "none", scrollTrigger: { trigger: el, start: "top bottom", end: "bottom top", scrub: true } });
        });
        gsap.utils.toArray(".rank-row-label, .rank-cell").forEach(function (el, i) {
          gsap.from(el, { opacity: 0, y: 10, duration: .5, delay: (i % 5) * .04, ease: "power2.out", scrollTrigger: { trigger: el, start: "top 92%", once: true } });
        });
        ScrollTrigger.refresh();
      }
      const trigger = document.getElementById("mobileTrigger");
      const nav = document.getElementById("primaryNav");
      if (trigger && nav) {
        trigger.addEventListener("click", function () {
          const open = nav.classList.toggle("is-open");
          trigger.setAttribute("aria-expanded", open ? "true" : "false");
        });
      }
    
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRefrigeratedConsolePage, { once: true });
  } else {
    initRefrigeratedConsolePage();
  }
}());
